import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { PlayerAuthRefreshRequest } from 'src/app/model/api/api-request/player-auth-refresh-request';
import { PlayerCreateRequest } from 'src/app/model/api/api-request/player-create-request';
import { PlayerPermissionsPutRequest } from 'src/app/model/api/api-request/player-permissions-put-request';
import { PlayerPutRequest } from 'src/app/model/api/api-request/player-put-request';
import { PlayerRequest } from 'src/app/model/api/api-request/player-request';
import { VisitorValidationRequest } from 'src/app/model/api/api-request/visitor-validation-request';
import { PlayerValidationResponse } from 'src/app/model/interfaces/player-validation-response';
import { PlayerAuthRefresh } from 'src/app/model/player-auth-refresh';
import { SimplePlayer } from 'src/app/model/simple-player';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ApiClient } from '../api-client/api-client';

@Injectable()
export class PlayerRepository {
    private readonly apiClient: ApiClient;
    private get webapiBasepath(): string {
        return this.environment.config['webapibasepath'];
    }

    public constructor(apiClient: ApiClient, private environment: AppConfigService) {
        this.apiClient = apiClient;
    }

    public createPlayer(player: SimplePlayer): Observable<SimplePlayer>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new PlayerCreateRequest(player, webapiBasepath);
        return this.apiClient.post(request);
    }

    public commitPlayer(player: SimplePlayer): Observable<any>
    {
        // const request = PlayerCommitRequest(player);
        // return this.apiClient.post(request);
        return null;
    }

    // public validatePlayer(player: SimplePlayer): Observable<PlayerValidationResponse> {
    //     const request = new PlayerValidationRequest(player, this.webapiBasepath);
    //     return this.apiClient.get<PlayerValidationResponse>(request);
    // }

    public async validatePlayer(player: SimplePlayer): Promise<PlayerValidationResponse>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new VisitorValidationRequest(player, webapiBasepath);
        return await firstValueFrom(this.apiClient.post<PlayerValidationResponse>(request));
    }

    public getAuthorizedPlayer(): Observable<any> {
        return this.apiClient.get(new PlayerRequest(this.webapiBasepath));
    }

    public updatePlayer(player: SimplePlayer): Observable<SimplePlayer> {
        const putRequest = new PlayerPutRequest(player, this.webapiBasepath);
        return this.apiClient.put(putRequest);
    }

    public updatePlayerPermissions(player: SimplePlayer): Observable<SimplePlayer> {
        const putRequest = new PlayerPermissionsPutRequest(player, this.webapiBasepath);
        return this.apiClient.put(putRequest);
    }

    public authRefresh(): Observable<PlayerAuthRefresh> {
      const sitecoreApiPath = this.environment.config['sitecoreapipath'];
      const request = new PlayerAuthRefreshRequest(sitecoreApiPath);
      return this.apiClient.get(request);
    }
}
